import React, { useEffect } from 'react';
import { App, Button, Card, Typography } from 'antd';

import apiClient from '../api/client';

const { Title, Text } = Typography;

const LoginPage: React.FC = () => {
  const { message } = App.useApp();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get('auth_error');
    if (error) {
      const msg =
        error === 'token_failed'
          ? 'Token exchange failed. Check backend logs.'
          : error === 'oauth_not_configured'
            ? 'Add MONDAY_OAUTH_CLIENT_SECRET to backend .env and restart.'
            : error === 'access_denied'
              ? 'You denied access. Try again.'
              : error === 'invalid_scope'
                ? 'Invalid OAuth scope. Check app config.'
                : `Sign in failed: ${error}`;
      message.error(msg);
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [message]);

  const handleSignIn = () => {
    const base = apiClient.defaults.baseURL || window.location.origin;
    window.location.href = `${base}/auth/monday/login`;
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        padding: 24,
      }}
    >
      <Card
        style={{ maxWidth: 400, width: '100%', textAlign: 'center' }}
        styles={{ body: { padding: 40 } }}
      >
        <Title level={3} style={{ marginBottom: 8 }}>
          Lead Ops
        </Title>
        <Text type="secondary" style={{ display: 'block', marginBottom: 32 }}>
          Sign in with Monday.com to continue
        </Text>
        <Button type="primary" size="large" onClick={handleSignIn} block>
          Sign in with Monday
        </Button>
      </Card>
    </div>
  );
};

export default LoginPage;
